export const CHOOSE_COLOR = {
    SUCCESS: "#009485",
    WARNING: "#FF9D65",
    DANGER: "#CE125D",
    INFO: "#0099ff",
}